import {createSlice} from '@reduxjs/toolkit';
import {IUserReducer} from '@/utils/types/user.interface';
import {getUserInfo, getUsersTablesAndTickets, userLogin, userLogout, userSignup} from './actions';
import {
	getUserInfoOperation,
	userLoginOperation,
	userLogoutOperation,
	userSignupOperation,
	pendingOperation,
	rejectedOperation,
	getUserTablesOperation,
} from './operations';

export const initialState: IUserReducer = {
	userInfo: null,
	isLoading: false,
	userTables: [],
};

const userStore = createSlice({
	name: 'user',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(userSignup.pending, pendingOperation);
		builder.addCase(userSignup.fulfilled, userSignupOperation);
		builder.addCase(userSignup.rejected, rejectedOperation);

		builder.addCase(userLogin.pending, pendingOperation);
		builder.addCase(userLogin.fulfilled, userLoginOperation);
		builder.addCase(userLogin.rejected, rejectedOperation);

		builder.addCase(userLogout.pending, pendingOperation);
		builder.addCase(userLogout.fulfilled, userLogoutOperation);
		builder.addCase(userLogout.rejected, rejectedOperation);

		builder.addCase(getUserInfo.pending, pendingOperation);
		builder.addCase(getUserInfo.fulfilled, getUserInfoOperation);
		builder.addCase(getUserInfo.rejected, rejectedOperation);

		builder.addCase(getUsersTablesAndTickets.pending, pendingOperation);
		builder.addCase(getUsersTablesAndTickets.fulfilled, getUserTablesOperation);
		builder.addCase(getUsersTablesAndTickets.rejected, rejectedOperation);
	},
});

export default userStore.reducer;
